<template lang="pug">
div(v-if='!isMobile')
  .w-100(@drop='drop', @dragenter='dragOver', @dragleave='dragleave')
    label.file-loader-area(
      v-if='!isDragging',
      for='formFile',
      aria-label='Área de upload de arquivos.'
    )
      .file-loader-area__icon
        img.icon.icon-img(
          src='https://cdn.soluti.com.br/libs/ilios/latest/img/icons/upload.svg'
        )
      .file-loader-area__text
        <strong>Clique para inserir</strong> ou arraste e solte o documento
      .file-loader-area__file-spec Formatos permitidos: JPEG, PNG, PDF, Word
      .file-loader-area__file-spec Tamanho máximo permitido: 25 MB por documento

    .file-loader-area.file-dragging(v-else)
      .file-loader-area__text
      strong Solte o documento aqui!

    input#formFile.d-none(
      multiple,
      ref='file',
      type='file',
      @change='inputChange'
    )
div(v-else)
  label.btn.w-100.btn-outline-primary.mt-2(
    for='formFile',
    aria-label='Botão de upload de arquivos.'
  )
    span Anexar documentos
    Icon.ms-2(:style='"width: 1.5rem; height: 1.5rem;"', name='cloud-arrow-up')

  input#formFile.d-none(
    multiple,
    ref='file',
    type='file',
    @change='inputChange'
  )
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'

  interface InputFileEvent extends Event {
    target: HTMLInputElement
  }

  interface InputFileDropEvent extends Event {
    dataTransfer: DataTransfer
  }

  export default defineComponent({
    name: 'UploadComponent',
    components: {
      Icon,
    },
    props: {
      isMobile: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      isDragging: false,
    }),
    methods: {
      dropFile(event: InputFileEvent) {
        this.$emit('addFile', event.target.files)
        this.isDragging = false
      },
      dragOver(e: InputFileEvent) {
        e.preventDefault()
        this.isDragging = true
      },
      dragleave() {
        this.isDragging = false
      },
      drop(e: InputFileDropEvent) {
        e.preventDefault()
        this.$emit('addFile', e.dataTransfer.files)
        this.isDragging = false
      },
      inputChange(event: InputFileEvent) {
        const input = this.$refs.file as HTMLInputElement
        this.$emit('addFile', event.target.files)
        input.value = ''
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .loaded-file
    text-align left
  .file-dragging
    border-color: var(--color-primary) !important
    border-width: 2px
    height: 12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-primary) !important
    background-color: var(--color-grayscale-light)
    opacity: 0.4

  .icon-img
    width: 53px;
    height: 60px;

  label
    cursor pointer
    width 100%
</style>
